import {
  prefetchInfinitePromoCategory,
  prefetchModalWindowTranslation,
  prefetchPage,
  prefetchTranslation,
  prefetchInlineBanners,
} from '@Navigation/prefetchers';

import type { LoaderFn } from '@Types/Router';

export const loader: LoaderFn = (query) => async (args) => {
  const { queryClient } = query;
  const { request } = args;
  const { pathname, search } = new URL(request.url);
  const slug = 'elax';
  const matches = pathname.match(/.*page-([0-9]{0,})$/);
  const pageNumber = Number(matches ? matches[1] : 1);

  return Promise.all([
    prefetchPage(request.url, queryClient),
    prefetchTranslation(request.url, queryClient),
    prefetchInfinitePromoCategory({ pathname, search, slug, pageNumber }, queryClient),
    prefetchModalWindowTranslation('Filters', queryClient),
    prefetchInlineBanners({ queryClient, slug, search }),
  ]);
};
